/**
 * AsyncComponent
 *
 * Exports a higher order component that makes it
 * possible to lazy load components for code splitting.
 *
 * Example:
 * const Dashboard = Async(() => import('./pages/Dashboard'));
 */

import React from 'react';

export default function asyncComponent(importComponent) {
	class AsyncComponent extends React.Component {
		state = {
			component: null,
		};

		async componentDidMount() {
			this._isMounted = true;
			const { default: component } = await importComponent();

			if (this._isMounted) {
				this.setState({
					component,
				});
			}
		}

		componentWillUnmount() {
			this._isMounted = false;
		}

		render() {
			const Component = this.state.component;

			return Component ? <Component {...this.props} /> : null;
		}
	}

	return AsyncComponent;
}



// WEBPACK FOOTER //
// ./src/hoc/AsyncComponent.js